import Vue from 'vue'
import Vuex from 'vuex'

import Questionnaire from './stores/Questionnaire'
import Media from './stores/Media'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Questionnaire: Questionnaire,
    Media: Media
  }
})
